import { useEffect as o } from "react";
function f(e) {
  o(() => {
    const n = () => {
      e();
    };
    return window.addEventListener("beforeunload", n), function() {
      window.removeEventListener("beforeunload", n);
    };
  }, [e]);
}
export {
  f as default
};
